import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_PATH } from "../Config/Config";

const redeemHandoff = async ({ code }) => {
  const response = await axios.post(`${API_BASE_PATH}/KeyLogging/handoff/redeem`, { code });

  return response.data;
};

const useRedeemHandoff = (options = {}) => {
  return useMutation({
    mutationFn: redeemHandoff,
    ...options,
  });
};

export default useRedeemHandoff;
